/**
 * 设置认证时间
 * @Author 3173
 */
import React from 'react';
import { connect } from 'dva';
import { component_tool, framework_tool } from '@/tool'
import { WizTableForm } from '@/containers/common';
import { modelUtils } from "@/utils";
import moment from "moment";

let { WizForm, WizTimePicker, WizSpin, WizButton } = component_tool

const formatterTime = (val) => {
  return val ? moment(val).format('HH:mm:ss') : '';
}
const personInfoConfig = WizTableForm.Config.user(this, { apiParams: { state: 1,positionIdList: ["110"]},path:'personManage/getTeachelist' })
let {
  WizContainer,
} = framework_tool;


class SetAuthDate extends WizContainer {
  componentName = 'setAuthDate';

  constructor(props) {
    super(props);
    let { record } = props;
    const { authDateStr, ownerId, startDateStr, endDateStr, id } = record
    this.state = {
      id,
      authDate: authDateStr,
      startDate: startDateStr,
      endDate: endDateStr,
      newStartDate: startDateStr,
      newEndDate: endDateStr,
      ownerId: ownerId,
      authChecking: false,
      isOpen: false,
      record: record && record,
      formKey: (new Date().getTime()),
    };
    this.initMsgAuth = "";
    this.msgAuth = "";
    this.isFirst = true;
    this.clearWizCallBack = [];
  }

  propsAndStateOnChange = {
    savestudentremoteauthowneridresult: this._updateOver.bind(this),
    checkauthtime: this._checkAuthTimeOver.bind(this),
  };

  _componentDidMount() {
    const { authDate, startDate, endDate, ownerId } = this.state;
    if (startDate && endDate && startDate != '' && endDate != '' && ownerId && ownerId != '') {
      this.verifyAuthTime(authDate + " " + startDate, authDate + " " + endDate, ownerId);
    } else {
      this.isFirst = false;
    }
  }

  /**
   * 保存后返回提示
   * @param nextProps
   * @param nextState
   * @private
   */
  _updateOver(nextProps, nextState) {
    if (nextProps.savestudentremoteauthowneridresult.code === 1) {
      wizNotice.success("操作成功");
      this.initMsgAuth = this.msgAuth;
      nextState.formKey=(new Date().getTime()),
      this.refreshList();
    } else {
      wizNotice.error(nextProps.savestudentremoteauthowneridresult.msg);
    }
    return true
  }

  /**
   * 保存后返回提示
   * @param nextProps
   * @param nextState
   * @private
   */
  _checkAuthTimeOver(nextProps, nextState) {
    if (nextProps.checkauthtime.code === 1) {
      this.msgAuth = nextProps.checkauthtime.data
      let isFirst = this.isFirst;
      if (isFirst) {
        this.initMsgAuth = this.msgAuth;
        this.isFirst = false;
      }
    } else {
      wizNotice.error(nextProps.checkauthtime.msg);
    }
    this.setState({
      authChecking: false
    })
    return true
  }

  /**
   * 更新原列表
   */
  refreshList() {
    let { changeModal } = this.props;
    changeModal && changeModal(false, true)
  }


  /**
   * 编辑
   */
  _update = () => {
    this.formData.validateFields((err, values) => {
      let value = Object.assign([], values)
      if (value['startDate'] && value['endDate']) {
        value['startDate'] = value['startDate']._d ? value['startDate']._d.getTime() : null
        value['endDate'] = value['endDate']._d ? value['endDate']._d.getTime() : null
        if (value['startDate'] && value['endDate'] && value['endDate'] <= value['startDate']) {
          return;
        }
      }
      let examId = this.state.record.examId;
      if(!examId || examId<=0){
        examId = null;
      }
      if (!err) {
        this.doAction({
          path: "studentRemoteAuthDetail/setStudentRemoteAuthOwnerId",
          payload: {
            key: "savestudentremoteauthowneridresult"+this.state.record.id,
            apiParams: {
              ...this.state.record,
              examId,
              ...value
            }
          }
        });
      }
      return
    });
  };

  _reset = () => {
    const { record } = this.state;
    const { authDateStr, ownerId, startDateStr, endDateStr, id } = record
    this.msgAuth = this.initMsgAuth;
    this.formData.resetFields();
    this.clearWizCallBack.forEach(callback => {
      callback && callback()
    });
    this.setState({
      id,
      authDate: authDateStr,
      startDate: startDateStr,
      endDate: endDateStr,
      newStartDate: startDateStr,
      newEndDate: endDateStr,
      ownerId: ownerId,
      authChecking: false,
      isOpen: false,
      record: record && record,
      formKey: (new Date().getTime()),
    })
    this.refreshList();
  }

  _onClearWiz(callback) {
    if (callback) {
      this.clearWizCallBack.push(callback)
    }
  }

  validateEndDate = (rule, value, callback) => {
    let startDate = this.formData.getFieldValue('startDate');
    if (!startDate) {
      callback('请先选择认证开始时间');
      return;
    }
    if (!value) {
      callback('请选择认证结束时间');
      return;
    }
    const { authDate } = this.state;
    let newStartDateTime = moment(authDate + ' ' + formatterTime(startDate));
    let newEndDateTime = moment(authDate + ' ' + formatterTime(value));
    if (newStartDateTime && newEndDateTime && moment(newEndDateTime).isBefore(newStartDateTime)) {
      callback('认证结束时间不能小于认证开始时间');
      return;
    }
    if (moment(newEndDateTime).diff(newStartDateTime) < 60000) {
      callback('认证结束时间与认证开始时间间隔不能小于1分钟');
      return;
    }
    callback();
  }

  /**
   * 更新时间
   * @param time
   * @param timeString
   * @param type 0 开始时间；1 结束数据
   */
  onChangeTime = (time, timeString, type) => {
    let newStartDate = this.state.newStartDate;
    let newEndDate = this.state.newEndDate;
    if (type === 0) {
      if (time === null || time === '') {
        newStartDate = null;
      } else {
        newStartDate = timeString;
      }
    }
    if (type === 1) {
      if (time === null || time === '') {
        newEndDate = null;
      } else {
        newEndDate = timeString;
      }
    }
    const { startDate, endDate, ownerId, authChecking, authDate, isOpen } = this.state;
    if (!isOpen) {
      this.checkAuthTimes(startDate, endDate, newStartDate, newEndDate, ownerId, authChecking, authDate);
    } else {
      this.setState({
        newStartDate,
        newEndDate,
      })
    }
  }

  /**
   * 校验认证时间是否有资源 先校验数据
   * @private
   */
  checkAuthTimes(startDate, endDate, newStartDate, newEndDate, ownerId, authChecking, authDate) {
    this.setState({
      newStartDate,
      newEndDate,
      startDate: newStartDate,
      endDate: newEndDate,
    });
    if (!authChecking && newStartDate != null && newStartDate != '' && newEndDate != null && newEndDate != '') {
      if (startDate === null || endDate === null || newStartDate != startDate || newEndDate != endDate) {
        let startDateTimeStr = authDate + " " + newStartDate;
        let endDateTimeStr = authDate + " " + newEndDate;
        let newStartDateTime = moment(startDateTimeStr);
        let newEndDateTime = moment(endDateTimeStr);
        if (newStartDateTime && newEndDateTime && (moment(newEndDateTime).isBefore(newStartDateTime) ||
          moment(newEndDateTime).diff(newStartDateTime) < 60000)) {
          this.msgAuth = "";
          return;
        }
        this.verifyAuthTime(startDateTimeStr, endDateTimeStr, ownerId);
      } else {
        if (newStartDate != startDate || newEndDate != endDate) {
          this.msgAuth = "";
        }
      }
    } else {
      this.msgAuth = "";
    }
  }

  /**
   * 在关闭时间插件时，校验开始时间结束时间值 是否存在资源
   * @param changedValues
   * @param allValues
   */
  onChangeOpen = (open) => {
    this.setState({
      isOpen: open
    })
    if (!open) {
      this.checkAuthTimesByOpenChange();
    }
  }

  /**
   * 校验认证时间是否有资源 先校验数据
   * @private
   */
  checkAuthTimesByOpenChange() {
    const { startDate, endDate, newStartDate, newEndDate, ownerId, authChecking, authDate } = this.state;
    if (!authChecking && newStartDate != null && newStartDate != '' && newEndDate != null && newEndDate != '') {
      if (startDate === null || startDate === '' || endDate === null || endDate === ''
        || newStartDate != startDate || newEndDate != endDate) {
        let startDateTimeStr = authDate + " " + newStartDate;
        let endDateTimeStr = authDate + " " + newEndDate;
        let newStartDateTime = moment(startDateTimeStr);
        let newEndDateTime = moment(endDateTimeStr);
        if (newStartDateTime && newEndDateTime && (moment(newEndDateTime).isBefore(newStartDateTime) ||
          moment(newEndDateTime).diff(newStartDateTime) < 60000)) {
          this.setState({
            startDate: newStartDate,
            endDate: newEndDate,
          })
          this.msgAuth = "";
          return;
        }
        this.setState({
          startDate: newStartDate,
          endDate: newEndDate,
        })
        this.verifyAuthTime(startDateTimeStr, endDateTimeStr, ownerId);
      } else {
        this.setState({
          startDate: newStartDate,
          endDate: newEndDate,
        })
        if (newStartDate != startDate || newEndDate != endDate) {
          this.msgAuth = "";
        }
      }
    } else {
      this.setState({
        startDate: newStartDate,
        endDate: newEndDate,
      })
      this.msgAuth = "";
    }
  }

  /**
   * 校验认证时间是否有资源
   * @private
   */
  verifyAuthTime(startDate, endDate, ownerId) {
    let { id } = this.state;
    if (!startDate || !endDate) {
      return;
    }
    this.setState({
      authChecking: true
    })
    this.doAction({
      path: 'studentRemoteAuthDetail/checkStudentRemoteAuthResources',
      payload: {
        key: 'checkauthtime' + id,
        apiParams: {
          startDate,
          endDate,
          ownerId
        }
      }
    });
  }

  setAuthColumns = (recordNew) => {
    return [
      {
        title: "讲师",
        name: "lectureId",
        formItem: {
          diy: WizTableForm,
          ...personInfoConfig,
          selectType: 'radio',
          initialValue: recordNew['lectureId'] ? [recordNew['lectureId']] : [],
          initRows: recordNew['lectureId'] ? [{
            id: recordNew['lectureId'],
            personId: recordNew['lectureId'],
            fullName: recordNew['lectureName']
          }] : [],
          rules: [{
            required: true,
            message: '请选择讲师',
          }],
          onClearWiz: this._onClearWiz.bind(this)
        }
      },
      {
        title: '认证开始时间',
        formItem: {
          type: 'custom',
          render: (record, form) => {
            const { getFieldDecorator } = form;
            return (
              <div>
                {
                  getFieldDecorator('startDate', {
                    rules: [{ required: true, message: '请选择认证开始时间', }],
                    initialValue: recordNew['startDate'] ? moment(recordNew['startDate']) : null
                  })(
                    <WizTimePicker placeholder={'请选择认证开始时间'}
                      onChange={(time, timeString) => {
                        this.onChangeTime(time, timeString, 0)
                      }}
                      onOpenChange={(open) => {
                        this.onChangeOpen(open)
                      }}
                    />
                  )
                }
              </div>
            )
          }
        }
      },
      {
        title: '认证结束时间',
        formItem: {
          type: 'custom',
          render: (record, form) => {
            const { getFieldDecorator } = form;
            return (
              <div>
                {
                  getFieldDecorator('endDate', {
                    rules: [{ required: true, validator: this.validateEndDate }],
                    initialValue: recordNew['endDate'] ? moment(recordNew['endDate']) : null
                  })(
                    <WizTimePicker
                      placeholder={'请选择认证结束时间'}
                      onChange={(time, timeString) => {
                        this.onChangeTime(time, timeString, 1)
                      }}
                      onOpenChange={(open) => {
                        this.onChangeOpen(open)
                      }}
                    />
                  )
                }
              </div>
            )
          }
        },
      },
      {
        formItem: {
          type: 'custom',
          render: () => {
            return (<div>
              {this.msgAuth && this.msgAuth}
            </div>)
          }
        }
      }
    ]
  }

  _render() {
    let { record, studentRemoteAuthDetailLoading } = this.props;
    const { newStartDate, newEndDate, authDate } = this.state;
    let recordNew = { ...record };
    let newStartDateTime = null;
    let newEndDateTime = null;
    if (newStartDate && newStartDate != null) {
      newStartDateTime = moment(authDate + ' ' + formatterTime(newStartDate));
    }
    if (newEndDate && newEndDate != null) {
      newEndDateTime = moment(authDate + ' ' + formatterTime(newEndDate));
    }
    // this.setState({
    //   record: record
    // });
    let columns = this.setAuthColumns(recordNew);
    return (
      <WizSpin tip={''} spinning={studentRemoteAuthDetailLoading}>
        <WizForm
          {...this.props}
          columns={columns}
          ref={r => {
            this.formData = r
          }}
          key={this.state.formKey}
        />
        <div class="ant-modal-footer">
        <WizButton onClick={this._reset.bind(this)}>取消</WizButton>
        <WizButton type="primary" style={{ marginLeft: 20 }} onClick={this._update.bind(this)}>确认</WizButton>
        </div>
      </WizSpin>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  let { record } = ownProps
  const { studentRemoteAuthDetail } = state;
  const savestudentremoteauthowneridresult = modelUtils.getModelEntity(studentRemoteAuthDetail, "savestudentremoteauthowneridresult"+ record.id);
  const checkauthtime = modelUtils.getModelEntity(studentRemoteAuthDetail, "checkauthtime" + record.id);
  const load = modelUtils.getLoadingState(state, ['studentRemoteAuthDetail']);
  return {
    savestudentremoteauthowneridresult,
    checkauthtime,
    ...load
  }
};
const options = { withRef: true };
export default connect(mapStateToProps, null, null, options)(SetAuthDate);
